<template>
  <div class="main-content" id="panel">
    <!-- HEADER -->
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-6 col-7">
              <h2 class="text-white">Customer Report</h2>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- BODY -->
    <div class="container-fluid mt--6">
      <div class="row justify-content-md-center">
        <div class="col-xl-12">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <h5 class="mb-0">Enter Details</h5>
            </div>

            <div class="card-body">
              <!-- FORM -->
              <div class="form-row">
                <!-- ROW 1 -->
                <div class="form-group col-md-4">
                  <label>Accounts</label>
                  <multiselect
                    v-model="form.customer"
                    placeholder="Select Accounts"
                    :options="accountList"
                    :multiple="true"
                    label="accountName"
                    track-by="accountMappingId"
                  >
                  </multiselect>
                </div>
                <div class="form-group col-md-2  required">
                  <label>Settlement From</label>
                  <datepicker
                    v-model="form.fromDate"
                    placeholder="mm/dd/yyyy"
                    name="fromDate"
                    format="MM/dd/yyyy"
                    :clear-button="true"
                    :calendar-button="true"
                    calendar-button-icon="fas fa-calendar-alt datepicker_icon"
                  />
                </div>
                <div class="form-group col-md-2 required">
                  <label>Settlement To</label>
                  <datepicker
                    v-model="form.toDate"
                    placeholder="mm/dd/yyyy"
                    name="toDate"
                    format="MM/dd/yyyy"
                    :clear-button="true"
                    :calendar-button="true"
                    calendar-button-icon="fas fa-calendar-alt datepicker_icon"
                  />
                </div>
                 <div class="form-group col-md-1 required">
                  <label>De Minimis</label>
                  <select v-model="isDeMinimis" class="form-control" style="height: 40px" name="isDeMinimis">
                    <option :value="null"  name="all">All</option>
                    <option :value="true" name="yes">Yes</option>
                    <option :value="false" name="no">No</option>

                  </select>
                </div>
               
                <div class="form-group col-md-2">
                  <button
                    class="btn btn-primary rounded mt-4"
                    type="button"
                    style="height: 40px;"
                    :disabled="isDisabled || loading"
                    @click="generateReport('initial')"
                  >
                    <span v-if="!loading">Generate Report</span>
                    <span v-else>
                      <i class="fa fa-spinner fa-spin mr-1"></i> Loading...
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- RESULT -->
          <div v-if="result" class="card mt-4 shadow">
            <div class="card-header bg-transparent d-flex justify-content-between align-items-center">
  
  <!-- LEFT: Title -->
  <h5 class="mb-0"></h5>

  <!-- RIGHT: Controls -->
  <div class="d-flex align-items-center" style="gap: 20px;">
    <!-- Export Type Select -->
    <div class="d-flex align-items-center" style="gap: 8px;">
      <label for="exportType" class="mb-0" style="font-size: .8125rem; white-space: nowrap;">Export As</label>
      <select id="exportType" v-model="exportType" class="form-control form-control-sm">
        <option value="pdf">PDF</option>
        <option value="excel">EXCEL</option>
      </select>
    </div>

    <!-- Export Button -->
    <button
      class="btn btn-sm btn-warning"
      type="button"
      :disabled="isExport || result.length === 0"
      @click="exportData()"
      style="white-space: nowrap;"
    >
      <span v-if="!isExport">Export</span>
      <span v-else>
        <i class="fa fa-spinner fa-spin mr-1"></i> Exporting...
      </span>
    </button>

  </div>
</div>

            <div class="card-body">
              <div class="row">
                <div class="col-xl-12">
                  <div class="card vh-75" id="scroll">
                    <div class="table-responsive">
                      <div v-if="loading" class="loader">
                        <img src="@/assets/img/loader.svg" alt="" />
                      </div>
                      <table
                        class="table align-items-center table-flush table-hover bidtbl"
                      >
                        <thead class="thead-light psticky">
                          <tr>
                            <th 
                              scope="col" 
                              class="sort"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                              @click="sort('cusip')">cusip / Description</th>
                            <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'accountNo'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'accountNo'  ? 'sort-desc' : '']"  
                              @click="sort('accountNo')"
                            >Account</th>
                            <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'tradeDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'tradeDate'  ? 'sort-desc' : '']"  
                              @click="sort('tradeDate')"
                            >trade date</th>

                            <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'settlementDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'settlementDate'  ? 'sort-desc' : '']"  
                              @click="sort('settlementDate')"
                            
                            >  Settlement Date
                            </th>
                           
                            <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'price'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'price'  ? 'sort-desc' : '']"  
                              @click="sort('price')"
                            >price</th>
                            <th scope="col" class="sort text-center">
                              de Minimis Status
                            </th>
                            <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'deMinimisThresholdPrice'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'deMinimisThresholdPrice'  ? 'sort-desc' : '']"  
                              @click="sort('deMinimisThresholdPrice')"
                            >
                              de Minimis Threshold Price
                            </th>
                          </tr>
                        </thead>
                        <tbody class="list no-cursor">
                          <tr v-if="result.length == 0 && !loading">
                            <td><p class="nodata">No data available</p></td>
                          </tr>
                          <tr v-for="data in result" :key="data.id">
                               <td >
                               <span class="cusips"  >{{data.cusip}}</span>
                              <span class="desc" >{{data.cusipDec}}</span>
                            </td>
                            <td class="text-center">{{ data.accountNo }} - {{data.firstName}} {{data.middleName}} {{data.lastName}}</td>
                            <td class="text-center">{{ data.tradeDate }}</td>
                            <td class="text-center">
                              {{ data.settlementDate }}
                            </td>
                         
                            
                            <td class="text-center">
                              {{ data.price | currency }}
                            </td>
                            <td class="text-center">
                              {{ data.deMinimisStatus == null ? '-' : data.deMinimisStatus ? 'Yes' : 'No' }}
                            </td>
                            <td class="text-center">
                              <span v-if="data.deMinimisThresholdPrice != null">
                              {{ data.deMinimisThresholdPrice | currency }}
                              </span>
                              <span v-else>-</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <!-- Pagination-->
                      <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="generateReport()"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import authService from '@/authService'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'TaxCalculatorComponent',
  components: {
    Datepicker
  },
  data () {
    return {
      form: {
        customer: '',
        fromDate: null,
        toDate: null
      },
      result: null,
      loading: false,
      isExport: false,
      customerList: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      sortColumn: 'tradeDate',
      sortOrder: 'DESC',
      isDeMinimis: true,
      exportType: 'excel',
      accountList: []
    }
  },

  computed: {
    isDisabled () {
      return !this.form.fromDate || !this.form.toDate
    }
  },

  methods: {
    deminisChanged(){
      this.generateReport('initial');
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.generateReport();
    },
    getCustomerList () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }

      this.$http
        .get(config.baseUrlAutoBidder + `/customer/name-list`, auth)
        .then(response => {
          this.customerList = response.data.map(data => {
            // Combine the name parts with spaces in between
            data.customerFullName = `${data.customerFirstName || ''} ${
              data.customerMiddleName || ''
            } ${data.customerLastName || ''}`.trim()
            return data
          })
        })
    },
    exportData () {
      this.isExport = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      let deminimisStatus = this.isDeMinimis === null ? '' : this.isDeMinimis ? true : false;
      var self = this;
      this.$http
        .get(config.baseUrlAutoBidder + '/pnl/customer-buys-report', { 
          ...auth, 
          params: { 
            accountMappingIds: this.form.customer ? this.form.customer.map(c => c.accountMappingId).join(',') : '',
            fileType: this.exportType,
            cognitoSub:  authService.getUser().cognitoSub,
            sortColumn: this.sortColumn,
            sortOrder: this.sortOrder,
            fromDate: this.form.fromDate
              ? this.moment(this.form.fromDate).utc().format('YYYY-MM-DD')
              : '',
            toDate: this.form.toDate
              ? this.moment(this.form.toDate).utc().format('YYYY-MM-DD')
              : '',
              deMinimisStatus: deminimisStatus
          }
        })
        .then((response) => {
          this.isExport = false
          window.open(response.data, '_blank')
        })
        .catch(error => {
                if(error.message.includes("504")){
                self.$fire({
                    title: "Download timed out",
                    type: 'warning',
                    html: 'Please check file logs to download the file.',
                    footer: '<a href="/de-minimis/de-minimis-file-log">Click here to see the file logs</a>'
                })
                    // self.$alert("Download timed out. Please check file logs to download the file.","","warning")
                }
                self.isExport = false;
          });
    },
    generateReport (type) {
      if (type === 'initial') {
        this.currentPage = 1
      }

      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }

      this.loading = true

      let deminimisStatus = this.isDeMinimis === null ? '' : this.isDeMinimis ? true : false;

      this.$http
        .get(config.baseUrlAutoBidder + '/pnl/customer-buys', {
          ...auth,
          params: {
            page: this.currentPage,
            size: this.perPage,
            sortColumn: this.sortColumn,
            sortOrder: this.sortOrder,
            accountMappingIds: this.form.customer ? this.form.customer.map(c => c.accountMappingId).join(',') : '',
            fromDate: this.form.fromDate
              ? this.moment(this.form.fromDate).utc().format('YYYY-MM-DD')
              : '',
            toDate: this.form.toDate
              ? this.moment(this.form.toDate).utc().format('YYYY-MM-DD')
              : '',
            deMinimisStatus: deminimisStatus
          }
        })
        .then(response => {
          this.result = response.data ? response.data.content : null
          this.totalRows = response.data ? response.data.pageInfo.totalElements : 0
        })
        .catch(err => {
          console.error(err)
          this.$notify({
            type: 'error',
            text: 'Failed to fetch tax details'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    getAllAccountList(){
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken() }
                };
                this.$http
                .get(
                config.baseUrlBidSide +
                    "/inventory/account-map-list",
                    auth
                )
                .then(result => {
                    this.accountList = result.data.map(item => {
                        return {
                            accountMappingId: item.accountMappingId,
                            account: item.account,
                            accountName: item.account + " - " + item.customerName
                        }
                    });
                    
                })
      }, 
  },
  mounted () {
    // this.getCustomerList()
    this.getAllAccountList();
  }
}
</script>

<style scoped>
.card {
  border-radius: 10px;
}

button.btn {
  min-width: 180px;
}

.text-muted {
  font-size: 12px;
}
.required label::after {
  content: " *";
  color: red;
}
</style>
